<template>
	<div>
		<div
			v-if="isLabelShow"
			class="formulate-input-label"
		>
			{{ label }}
		</div>
		<div
			class="custom-formulate-file-uploader--input"
			:class="`formulate-input-element formulate-input-element--${context.class}`"
			:data-type="context.type"
		>
			<div v-if="files.length > 0" class="formulate-file-names">
				<div
					v-for="(file, index) in files"
					:key="file.name"
					class="w-100 d-flex justify-content-between"
				>
					<span class="mr-2 formulate-file-name"> {{ file.name }}</span>
					<div class="formulate-file-remove" @click="removeFile(index)" />
				</div>
			</div>
			<div v-else class="formulate-input-upload-area">
				<input
					ref="fileInput"
					type="file"
					multiple
					accept=".pdf,.jpg,.jpeg,.docx"
					:name="context?.attributes?.name"
					@change="handleFileChange"
				>

				<div class="col-12 loader-file" @click="openFileDialog" />
			</div>
		</div>
	</div>
</template>

<script>
const MAX_FILE_SIZE = 50 * 1024 * 1024;

export default {
	props: {
		context: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			model: [],
			files: [],
		};
	},
	computed: {
		isLabelShow() {
			if (this.context.attributes.is_label_hide) return false;
			return true;
		},
		required() {
			return !!this.context.rules.find((el) => el.ruleName === 'required');
		},
		label() {
			const label = this.context.attributes['label-text'];
			const required = this.required ? '*' : '';

			return label ? `${label}${required}` : '';
		},
	},
	watch: {
		model: {
			handler(value) {
				this.context.model = value;
			},
		},
	},
	async created() {
		this.autocomplete();
	},
	methods: {
		async autocomplete() {
			this.files = this.context.model && this.context.model !== '' ? this.context.model.map((el) => el) : [];
			this.model = this.files.map((el) => el.name);
		},
		openFileDialog() {
			this.$refs.fileInput.click();
		},
		fileToBinary(file) {
			return new Promise((resolve, reject) => {
				const reader = new FileReader();

				reader.onload = function (event) {
					const binaryData = event.target.result;
					resolve(binaryData);
				};
				reader.onerror = function (event) {
					reject(new Error('Ошибка чтения файла'));
				};
				reader.readAsDataURL(file);
			});
		},
		handleFileChange(event) {
			const selectedFile = event.target.files[0];

			if (
				['application/pdf', 'image/jpeg', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'].includes(selectedFile.type)
				&& selectedFile.size <= MAX_FILE_SIZE
			) {
				this.fileToBinary(selectedFile)
					.then((binaryData) => {
						this.files.push({
							file: binaryData,
							name: selectedFile.name,
							size: selectedFile.size,
							progress: 0,
							uploading: false,
						});
						this.model.push(binaryData);
					})
					.catch((error) => {
						console.error('Ошибка:', error);
					});
			} else {
				alert(`Файл "${selectedFile.name}" не принят (недопустимый формат или превышен размер 10 МБ)`);
			}
			// Сбрасываем input
			event.target.value = '';
		},
		removeFile(index) {
			this.files.splice(index, 1);
			this.model.splice(index, 1);
		},
	},
};
</script>

<style lang="scss" scoped>
@import '~/assets/styles/sk_variables';

.formulate-file-names {
    border-radius: 0 !important;
    border: 0px solid #949ABA !important;
    border-bottom: 1px solid #949ABA !important;
    font-size: 1rem;
    padding: 0.5rem 1rem 0.5rem 0rem !important;
    line-height: 1.2 !important;
    height: auto;
    // font-family: "Raleway", sans-serif;
    // font-weight: 500;
}

.formulate-input .formulate-input-upload-area input:hover ~ .loader-file {
    border-color: $blue !important;

    &::before {
        background-color: $blue !important;
    }
}

.formulate-input-upload-area input {
    cursor: pointer;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    opacity: 0;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 5;
}

.formulate-file-remove {
    width: 1.25em;
    height: 1.25em;
    border-radius: 1em;
    border: 1px solid #a8a8a8;
    background-color: #a8a8a8;
    mask-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 59.1 59.2"><path d="M1.6,57.7a5,5,0,0,0,3.5,1.5,4.85,4.85,0,0,0,3.5-1.5l21-21,21,21a5,5,0,0,0,3.5,1.5,4.85,4.85,0,0,0,3.5-1.5,5,5,0,0,0,0-7.1l-21-21,21-21a5,5,0,0,0,0-7.1,5,5,0,0,0-7.1,0l-21,21L8.6,1.7a5,5,0,0,0-7.1,0,5,5,0,0,0,0,7.1l21,21L1.6,50.7A4.83,4.83,0,0,0,1.6,57.7Z"/></svg>');
    -webkit-mask-size: 0.6em;
    mask-size: 0.6em;
    -webkit-mask-repeat: no-repeat;
    mask-repeat: no-repeat;
    -webkit-mask-position: center;
    mask-position: center;
    cursor: pointer;
    position: absolute;
    right: 0.75em;
    z-index: 1;
    transition: transform 0.25s;
}

.loader-file {
    border-radius: 0rem !important;
    border: 2px dashed #949ABA !important;

    height: 3rem;
    pointer-events: none;
    display: flex;
    justify-content: center;
    align-items: center;
    &::before {
        background-color: #949ABA !important;
        content: "";
        mask-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 58 58"><path d="M29,58A29,29,0,1,0,0,29,29,29,0,0,0,29,58ZM29,4A25,25,0,1,1,4,29,25,25,0,0,1,29,4Z"/><polygon points="27 22 27 44.4 31 44.4 31 22 41.7 31.1 44.3 28.1 29 15 13.7 28.1 16.3 31.1 27 22"/></svg>');
        mask-position: center;
        width: 2em;
        height: 2em;
        position: absolute;
        pointer-events: none;
    }
}

.formulate-file-name {
    display: flex;
    align-items: flex-end;

    &::before {
        background-color: #a8a8a8;
        content: "";
        mask-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64.06 83.59"><path d="M55.94,83.59a8.16,8.16,0,0,0,8.12-8.16V19.12a1.77,1.77,0,0,0-.52-1.25L46.21.59A1.69,1.69,0,0,0,45.14.08L44.69,0l-.18,0H8.13A8.18,8.18,0,0,0,0,8.16V75.41a8.16,8.16,0,0,0,8.13,8.16H55.94ZM46.68,6,58.11,17.38H46.68ZM3.52,75.43V8.16A4.64,4.64,0,0,1,8.13,3.52h35V19.16a1.75,1.75,0,0,0,1.76,1.74H60.55V75.43a4.65,4.65,0,0,1-4.61,4.65H8.13A4.65,4.65,0,0,1,3.52,75.43Z"/></svg>');
        -webkit-mask-repeat: no-repeat;
        mask-repeat: no-repeat;
        -webkit-mask-size: contain;
        mask-size: contain;
        width: 1.25em;
        height: 1.25em;
        display: inline-block;
        margin-right: 0.5em;
    }
}

progress {
  margin-left: 10px;
  width: 200px;
}
</style>
